import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  en: {
    translation: {},
  },
  es: {
    translation: {
      // General
      close: "Cerrar",
      save_changes: "Guardar cambios",
      create: "Crear",
      actions: "Acciones",
      remove: "Eliminar",
      successfull_action: "Acción realizada con éxito",
      bd_connections: "Conexiones BD",
      save_changes_and_new: "Guardar cambios y nuevo",
      search_by_reference: "Buscar por referencia",

      // Auths
      sign_up: "Identificarse",
      email_or_user: "Correo o usuario",
      email_or_user_placeholder: "Ingrese su correo o usuario",
      password: "Contraseña",
      password_placeholder: "Ingrese su contraseña",
      sign_in: "Iniciar sesión",
      forgot_password: "¿Olvidaste tu contraseña?",
      logout: "Cerrar sesión",

      // Customers
      customers: "Clientes",
      customer: "Cliente",
      "Create customer": "Crear cliente",
      "are_you_sure_you_want_to_remove_this_customer?":
        "¿Estás seguro de que deseas eliminar este cliente?",
      surnames: "Apellidos",
      phone: "Teléfono",
      mobile: "Móvil",
      nif: "DNI",
      address: "Dirección",
      city: "Ciudad",
      state: "Provincia",
      postal_code: "Código postal",
      observations: "Observaciones",
      customers_and_pets: "Clientes y mascotas",
      customer_data: "Datos del cliente",
      customer_info: "Cliente",
      customer_id: "Cliente",

      // Pets
      pets: "Mascotas",
      pet: "Mascota",
      "Create pet": "Crear mascota",
      "are_you_sure_you_want_to_remove_this_pet?":
        "¿Estás seguro de que deseas eliminar esta mascota?",
      breed: "Raza",
      fee_id: "Tarifa",
      gender: "Género",
      feed: "Pienso",
      eat: "Tomas",
      eat_quantity: "Cantidad por toma (gr)",
      disease: "Enfermedades",
      passport: "Pasaporte",
      microchip: "Microchip",
      description: "Descripción",

      // Bookings
      bookings: "Reservas",
      booking: "Reserva",
      "Create booking": "Crear reserva",
      "are_you_sure_you_want_to_remove_this_booking?":
        "¿Estás seguro de que deseas eliminar esta reserva?",
      reference: "Referencia",
      start_date_time: "Fecha de entrada",
      end_date_time: "Fecha de salida",
      total_price: "Precio total",
      price_per_day: "Precio por día",
      pet_id: "Mascota",
      room_id: "Habitación",
      observation: "Observaciones",
      new_booking: "Nueva reserva",
      days: "Días",
      extra_id: "Suplemento",
      quantity: "Cantidad",
      arrival_bookings: "Entradas",
      departure_bookings: "Salidas",
      checked_in_from: "Entradas desde",
      checked_in_to: "Entradas hasta",
      to_pick_up: "Recogida",
      calendar: "Calendario",
      from: "Desde",
      to: "Hasta",
      pick_up: "Recogida",
      to_deliver: "Entrega",
      haircut: "Peluquería",
      checked_out_from: "Salidas desde",
      checked_out_to: "Salidas hasta",
      checked_in: "Ha entrado",
      checked_out: "Ha salido",
      cancelled: "Cancelada",
      breeds: "Razas",
      cancel: "Cancelar",
      "are_you_sure_you_want_to_cancel_this_booking?":
        "¿Estás seguro de que deseas cancelar esta reserva?",
      uncancel: "Deshacer cancelación",
      "are_you_sure_you_want_to_uncancel_this_booking?":
        "¿Estás seguro de que deseas deshacer la cancelación de esta reserva?",
      "send-email": "Enviar email",
      "are_you_sure_you_want_to_send_the_email_of_this_booking?":
        "¿Estás seguro de que deseas enviar el email de esta reserva?",
      download: "Descargar",
      // Bulk/acciones
      "create-delivery-note": "Generar albarán",
      "create-invoice": "Crear factura",
  "generate-invoice-pdf": "Generar PDF factura",
  "are_you_sure_you_want_to_generate_the_invoice_pdf_for_this_booking?": "¿Seguro que deseas generar el PDF de la factura de esta reserva?",
  "are_you_sure_you_want_to_generate_the_delivery_note_for_these_booking?": "¿Seguro que deseas generar el albarán para estas reservas?",
  "are_you_sure_you_want_to_generate_the_invoice_for_these_booking?": "¿Seguro que deseas generar la factura para estas reservas?",
  "are_you_sure_you_want_to_generate_the_invoice_for_these_bookings?": "¿Seguro que deseas generar la factura para estas reservas?",
  "are_you_sure_you_want_to_generate_the_delivery_note_for_these_bookings?": "¿Seguro que deseas generar el albarán para estas reservas?",

      // Payments
      payments: "Pagos",
  invoices: "Facturas",
  invoice: "Factura",
      created_at: "Fecha",
      amount: "Importe",
        amount_without_vat: "Importe sin IVA",
        amount_vat: "IVA",
        amount_with_vat: "Importe con IVA",
      payed: "Pagado",
      "are_you_sure_you_want_to_pay_this_payment?":
        "¿Estás seguro de que deseas pagar esta reserva?",
      "are_you_sure_you_want_to_pay_this_booking?":
        "¿Estás seguro de que deseas pagar esta reserva?",
      unpay: "Deshacer pago",
      "are_you_sure_you_want_to_un_pay_this_booking?":
        "¿Estás seguro de que deseas deshacer el pago de esta reserva?",

      // Usuarios
      users: "Usuarios",
      name: "Nombre",
      email: "Correo",
      password_confirmation: "Confirmación de contraseña",
      role: "Rol",
      remove_user: "Eliminar usuario",
      "are_you_sure_you_want_to_remove_this_user?":
        "¿Estás seguro de que deseas eliminar este usuario?",

      // Métodos de pagos
      payment_methods: "Métodos de pago",
      "payment-methods": "Métodos de pago",
      "Create payment-metho": "Crear método de pago",
      "are_you_sure_you_want_to_remove_this_payment-method?":
        "¿Estás seguro de que deseas eliminar este método de pago?",

      // Rooms
      rooms: "Habitaciones",
      room: "Habitación",
      "Create room": "Crear habitación",
      "are_you_sure_you_want_to_remove_this_room?":
        "¿Estás seguro de que deseas eliminar esta habitación?",
      shed: "Nave",
      dog: "Perro",
      available: "Disponible",
      cat: "Gato",

      // Fees
      fees: "Tarifas",
      fee: "Tarifa",
      "Create fee": "Crear tarifa",
      "are_you_sure_you_want_to_remove_this_fee?":
        "¿Estás seguro de que deseas eliminar esta tarifa?",
      price: "Precio por día",

      // Extras
      extras: "Suplementos",
      extra: "Suplemento",
      "Create extra": "Crear suplemento",
      "are_you_sure_you_want_to_remove_this_extra?":
        "¿Estás seguro de que deseas eliminar este suplemento?",
      extra_price: "Precio",
      type: "Tipo",
      type_0: "Servicio",
      type_1: "Por día",

      // Holidays
      holidays: "Festivos",
      holiday: "Festivo",
      "Create holiday": "Crear festivo",
      "are_you_sure_you_want_to_remove_this_holiday?":
        "¿Estás seguro de que deseas eliminar este festivo?",
      date: "Fecha",

      // Actividad de usuarios
      users_activity: "Actividad de usuarios",

      // Sidebar
      configurations: "Configuraciones",
      booking_texts: "Textos de reserva",
      booking_email_template: "Plantilla de email de reserva",
      booking_pdf_template: "Plantilla de PDF de reserva",
      agreement_pdf_template: "Plantilla de PDF de contrato",

      // Reports
      billing: "Facturación",
      granularity: "Granularidad",
      reports: "Informes",
      setting: "Configurar",
      "custom-reports": "Informes personalizados",
      widgets: "Widgets",
      measure: "Medida",
      period: "Periodo",
      "Edit custom-report": "Edit custom-report",
      start_date: "Fecha de inicio",
      end_date: "Fecha de fin",

      // bd-connections
      fieldFrom: "Campo origen",
      fieldFromType: "Tipo de campo origen",
      fieldTo: "Campo destino",
      fieldToType: "Tipo de campo destino",
      mapping: "Mapeo",
      table_from: "Tabla destino",
      table_to: "Tabla origen",
      "bd-connections": "Conexiones BD",

      // Otros
      updates: "Actualizaciones",
      integrations: "Integraciones",
      export: "Exportar",
      Mo: "Lu",
      Tu: "Ma",
      We: "Mi",
      Th: "Ju",
      Fr: "Vi",
      Sa: "Sá",
      Su: "Do",
      
  // Billing / Invoices
  serial: "Serie",
  number: "Número",
  expiration_date: "Fecha de vencimiento",
  currency: "Moneda",
  notes: "Notas",
  issuer_account: "Cuenta emisora",
  receiver_account: "Cuenta destinataria",
  product: "Producto",
      
  tax_percentage: "Porcentaje IVA",
      
  tax_amount: "Importe IVA",
  total: "Total",
  invoice_lines: "Líneas de factura",
  total_amount: "Importe total",
  status: "Estado",
  unpaid: "Pendiente",
  paid: "Pagada",
  rejected: "Rechazada",
  with_iva: "Con IVA",
  irpf_retention: "Retención IRPF",
  base_total_amount: "Base imponible",
  iva_total: "IVA total",
  irpf_retention_total: "Total retención IRPF",
      
  // Yes/No common
  yes: "Sí",
  no: "No",

  // Invoice pages headers
  "invoice line": "Línea de factura",
  "invoice configuration": "Configuración de factura",
  invoicecertificate: "Certificado de factura",
      
  // Invoice actions
  generate_pdf: "Generar PDF",
  separated_invoices: "Facturas separadas",
  "download-invoice-pdf": "Descargar PDF factura",
  "regenerate-invoice-pdf": "Regenerar PDF factura",
  edit_invoice: "Editar factura",
  generate_facturae: "Generar Facturae",
  "are_you_sure_you_want_to_generete_the_invoice_pdf?": "¿Seguro que deseas generar el PDF de la factura?",
  "are_you_sure_you_want_to_regenerate_the_invoice_pdf?": "¿Seguro que deseas regenerar el PDF de la factura?",
  "are_you_sure_you_want_to_generete_the_invoice_facturae?": "¿Seguro que deseas generar el fichero Facturae de la factura?",
  remove_invoice: "Eliminar factura",
  "are_you_shure_you_want_to_delete_this_invoice?": "¿Estás seguro de que deseas eliminar esta factura?",
  
  // Delivery Notes
  delivery_notes: "Albaranes",
  "Delivery Notes": "Albaranes",
  delivery_note: "Albarán",
  delivery_note_lines: "Líneas de albarán",
  create_delivery_note: "Crear albarán",
  edit_delivery_note: "Editar albarán",
  remove_delivery_note: "Eliminar albarán",
  "are_you_shure_you_want_to_delete_this_delivery_note?": "¿Estás seguro de que deseas eliminar este albarán?",
  "are_you_sure_you_want_to_generete_the_delivery_note_pdf?": "¿Seguro que deseas generar el PDF del albarán?",
  "download-delivery-note-pdf": "Descargar PDF albarán",
  "are_you_sure_you_want_to_generate_the_delivery_note_pdf_for_this_booking?": "¿Seguro que deseas generar el PDF del albarán para esta reserva?",
  "generate-delivery-note-pdf": "Generar PDF albarán",
  "generate-delivery-note": "Generar albarán",
  "pay": "Pagar",
  "agreement": "Descargar acuerdo",
  "delete": "Eliminar",
  all: "Todas",
  all_bookings: "Todas las reservas",
  with_invoice: "Con factura",
  without_invoice: "Sin factura",
  with_delivery_note: "Con albarán",
  without_delivery_note: "Sin albarán",
  
  // New sync and replicate actions
  synced_with_verifactu: "Sinc. VeriFactu",
  synced_with_accounting: "Sinc. gestoría",
  sync_verifactu: "Sincronizar con VeriFactu",
  send_to_accounting: "Enviar a gestoría",
  "are_you_sure_you_want_to_sync_with_verifactu?": "¿Seguro que deseas sincronizar con VeriFactu?",
  "are_you_sure_you_want_to_send_to_accounting?": "¿Seguro que deseas enviar a la gestoría?",
  send_to_customer: "Enviar a cliente",
  replicate_invoice: "Copiar factura",
  replicate_delivery_note: "Copiar albarán",
  "are_you_sure_you_want_to_replicate_this_invoice?": "¿Seguro que deseas copiar esta factura?",
  "are_you_sure_you_want_to_replicate_this_delivery_note?": "¿Seguro que deseas copiar este albarán?",
  requires_generate_pdf: "(requiere generar PDF)",
    },
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "es", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
